export enum StringFilterMatchMode {
    Contains = 10,
    NotContains = 11,
    StartsWith = 12,
    EndsWith = 13,
    Equals = 14,
    NotEquals = 15,
    In = 16
}
